import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { SmsPushNotificationService } from '../sms-push-notification.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastmessageService } from 'src/app/toastmessage.service';
import { map, Observable, startWith } from 'rxjs';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { DateAdapter } from '@angular/material/core';

@Component({
  selector: 'app-push-notification',
  templateUrl: './push-notification.component.html',
  styleUrls: ['./push-notification.component.scss']
})
export class PushNotificationComponent implements OnInit {
  migrationForm: any
  scheduleControl = new FormControl();
  minDate: Date = new Date();
  academicYears = ['2022-23', '2023-24', '2024-25'];
  FeeHeaddata = [
    {
      "id": 1, "headName": "akasBook"
    },
    {
      "id": 2, "headName": "unifrom"
    },
    {
      "id": 3, "headName": "digitalpayment"
    }
  ];
  citydata: any;
  campusdata: any;
  sectiondata: any;
  cityOptions: Observable<any[]>;
  citdId: any;
  campusOptions: Observable<any[]>;
  sectionOptions: Observable<any[]>;
  campusId: any;
  headOptions: any;
  date: any
  today = new Date();
  payload: any;
  template: any;

  constructor(private notification: SmsPushNotificationService, private spinner: NgxSpinnerService, private fb: FormBuilder, private toast: ToastmessageService) { }
  ngOnInit(): void {
    // this.adapter.setLocale('en-GB');
    this.migrationForm = new FormGroup({
      "SectionControl": new FormControl(),
      "CityControl": new FormControl(),
      "CampusControl": new FormControl(),
      "CityControl2": new FormControl(),
      "CampusControl2": new FormControl(),
      "SectionControl2": new FormControl(),
      "HeadControl": new FormControl(),
      "HeadControl2": new FormControl(),
      "template": new FormControl(),
      "templatel2": new FormControl(),
      "selectedDate": new FormControl()
    })
    this.citylist()


  }
  savestudent() {
    this.payload = {
      "sectionlist": this.migrationForm.get('SectionControl')?.value
    }
    console.log(this.payload);

  }
  citylist() {
    this.notification.getcity().subscribe(res => {
      this.citydata = res
      this.cityOptions = this.migrationForm.get('CityControl2').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.citydata, 'cityName'))
      );
      console.log(this.cityOptions);

    })
  }
  campuslist(citdId: any) {
    this.notification.getcampus(citdId).subscribe(res => {
      this.campusdata = res
      this.campusOptions = this.migrationForm.get('CampusControl2').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.campusdata, 'campusName'))
      );
      console.log(this.campusOptions);

    })

  }
  sectionlist(campusId: any) {
    this.notification.getsection(campusId).subscribe(res => {
      this.sectiondata = res
      this.sectionOptions = this.migrationForm.get('SectionControl2').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.sectiondata, 'sectionName'))
      );
    })
  }
  private Filter(value: string, list: any[], name: any): any[] {
    const searchValue = value.trim().toLocaleLowerCase();
    let filteredList = list.filter((item: any) => item[name] && item[name].toString().trim().toLocaleLowerCase().includes(searchValue));
    // console.log(filteredList)
    return filteredList;
  }
  getCampus(e: any) {
    console.log("city", e);
    this.citdId = e.cityId
    console.log("cityid", this.citdId);
    this.campuslist(this.citdId)
  }
  getsection(e: any) {
    console.log("campus", e);
    this.campusId = e.campusId
    console.log("campusId", this.campusId);
    this.sectionlist(this.campusId)
  }
  getCampus1(){
    this.gettemplate()
  }
  FeeHead() {
    this.FeeHeaddata
    this.headOptions = this.migrationForm.get('SectionControl2').valueChanges.pipe(
      startWith(''),
      map((value: any) => this.Filter(value, this.FeeHeaddata, 'headName'))
    );
    this.gettemplate()
  }
  head(e: any) {
    this.FeeHead()
  }
  clearCampus() {

  }
  gettemplate() {
    this.notification.gettemplate().subscribe(res => {
      this.template = res
      this.campusOptions = this.migrationForm.get('templatel2').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.template, 'template'))
      );
    })
  }
}


